import { trustReasons, trustStats } from '@/mocks/homeData';

export default function TrustSection() {
  return (
    <section id="trust" className="scroll-mt-24 w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-5">
            <div className="w-full h-72 md:h-[420px] rounded-lg overflow-hidden bg-background-200 border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20calm%20archive%20shelf%20built%20from%20simple%20geometric%20paper%20blocks%2C%20warm%20terracotta%20sand%20and%20olive%20palette%2C%20soft%20paper%20grain%20texture%2C%20portrait%20magazine%20composition%2C%20generous%20negative%20space%2C%20quiet%20trustworthy%20mood%2C%20no%20text&width=720&height=900&seq=hlzl-trust-visual&orientation=portrait"
                alt="长期维护的地址归档示意"
                title="黑料地址永久链接 长期维护"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.16em] text-secondary-700 uppercase">
              <i className="ri-shield-star-line" aria-hidden="true" />
              Why Bookmark
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              为什么说收藏本页就够了
            </h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">
              我们把「找地址」这件事从你手里接过来。你只需要记住一个稳定的入口页面，其余关于地址变化、屏蔽应对、线路切换的琐事，都由我们跟进处理。
            </p>

            <ul className="mt-8 space-y-4">
              {trustReasons.map((reason, index) => (
                <li key={reason.id} className="flex gap-4 animate-fade-up" style={{ animationDelay: `${index * 100}ms` }}>
                  <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-md bg-accent-100 text-accent-800">
                    <i className="ri-check-double-line" aria-hidden="true" />
                  </span>
                  <div>
                    <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">{reason.title}</h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">{reason.description}</p>
                  </div>
                </li>
              ))}
            </ul>

            <div className="mt-8 grid grid-cols-3 gap-4 pt-6 border-t border-background-200">
              {trustStats.map((item) => (
                <div key={item.id}>
                  <p className="font-heading text-xl md:text-2xl font-bold text-primary-600">{item.value}</p>
                  <p className="mt-1 text-[11px] md:text-xs font-label text-foreground-600">{item.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}